import { Configuration, PopupRequest } from "@azure/msal-browser";

const isLocalOneHost =
  window.location.hostname === "localhost" && window.location.port === "3000";

export const isLocalAuthBypassed =
  process.env.NODE_ENV === "development" && isLocalOneHost;

const msalClientId =
  process.env.REACT_APP_MSAL_CLIENT_ID || "00000000-0000-0000-0000-000000000000";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    // MSAL expects tenant authority base URL (not /authorize endpoint).
    authority: "https://login.microsoftonline.com/df505f9d-2555-419d-8720-93d1c7c0d8a9",
    clientId: msalClientId,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email", "offline_access", "user.read"],
};
